var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobileSvgLine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 372,
    height: 175,
    viewBox: "0 0 372 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.682 168.109L144.389 172.148L140.097 168.109",
    stroke: "#387FF1",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "12 12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.109 81.6056C336.975 86.9077 288.111 106.723 278.708 83.5307C267.347 55.5051 316.328 62.0697 326.427 94.3879C331.671 111.169 320.115 146.904 290.575 137.562C261.035 128.22 174.938 -5.09023 121.664 34.5495C68.3906 74.1892 -19.7257 47.9307 4.76511 18.3903C29.2559 -11.1501 64.3509 -3.32294 74.9551 47.6785C85.5594 98.6799 25.9736 111.052 40.3651 137.562C54.7566 164.073 145.398 98.9323 144.64 146.904C144.453 158.771 144.388 173.246 144.64 166.093",
    stroke: "#387FF1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "12 12"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileSvgLine);
export default __webpack_public_path__ + "static/media/mobileSvgLine.1aa4ad0643e88bdf902fc406c2a58d9e.svg";
export { ForwardRef as ReactComponent };